const InternalNofification = ({ title, body, onClose }) => {
    return (
        <div style={{
            backgroundColor: '#111827',
            color: '#F9FAFB',
            borderRadius: '14px',
            padding: '16px',
            boxShadow: '0 16px 40px rgba(15, 23, 42, 0.25)',
            minWidth: '320px',
            maxWidth: '380px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                <h3 style={{ margin: 0, fontSize: '16px' }}>{title}</h3>
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#F9FAFB',
                        fontSize: '20px',
                        cursor: 'pointer',
                        lineHeight: 1,
                        padding: 0
                    }}
                    aria-label="Close notification"
                >
                    ×
                </button>
            </div>
            <p style={{ margin: 0, lineHeight: 1.6, color: '#E5E7EB' }}>{body}</p>
        </div>
    );
};

export default InternalNofification;
